import styled from "styled-components";
import theme from "../../../style/theme";
import { PostCodeButton } from "../../button/PostCodeButton";
import { GeneralTextField } from "../../text-field/GeneralTextField";
import { WorkPlaceForm } from "./DeliveryDialog";
import Asterisk from "../../asterisk/asterisk";

interface Props {
  addressForm: string;
  workPlaceForm: WorkPlaceForm;
  deliveryPayloadValidatorAddress: boolean;
  deliveryPayloadValidatorDetail: boolean;
  setAddressForm: React.Dispatch<React.SetStateAction<string>>;
  setWorkPlaceForm: React.Dispatch<React.SetStateAction<WorkPlaceForm>>;
}

export const NewLocationSearchCard: React.FC<Props> = ({
  addressForm,
  workPlaceForm,
  deliveryPayloadValidatorAddress,
  deliveryPayloadValidatorDetail,
  setAddressForm,
  setWorkPlaceForm,
}) => {
  const handleChangeWorkPlaceFormTextField = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setWorkPlaceForm({
      ...workPlaceForm,
      [event.target.name]: event.target.value,
    });
  };

  const setAddress = (address: string) => {
    setAddressForm(address);
  };

  return (
    <SelectRecentLocationCardContainer>
      <FlexContainer>
        <FlexLeftContainer>상호명</FlexLeftContainer>
        <FlexRightContainer>
          <GeneralTextField
            name={"name"}
            value={workPlaceForm.name}
            onChange={handleChangeWorkPlaceFormTextField}
            width="311px"
          />
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>주소<Asterisk/></FlexLeftContainer>
        <FlexRightContainer>
          <GeneralTextField
            placeholder="장소를 검색하세요"
            value={addressForm}
            width="311px"
            isError={deliveryPayloadValidatorAddress}
            disabled
          />
          <PostCodeButtonContainer>
            <PostCodeButton setAddress={setAddress} />
          </PostCodeButtonContainer>
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>상세주소<Asterisk/></FlexLeftContainer>
        <FlexRightContainer>
          <GeneralTextField
            name={"detail"}
            value={workPlaceForm.detail}
            onChange={handleChangeWorkPlaceFormTextField}
            width="410px"
            isError={deliveryPayloadValidatorDetail}
          />
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>층</FlexLeftContainer>
        <FlexRightContainer>
          <GeneralTextField
            name={"floor"}
            value={workPlaceForm.floor}
            onChange={handleChangeWorkPlaceFormTextField}
            width="42px"
          />
          <FloorField>층</FloorField>
        </FlexRightContainer>
      </FlexContainer>
      <FlexContainer>
        <FlexLeftContainer>연락처</FlexLeftContainer>
        <FlexRightContainer>
          <GeneralTextField
            name={"phone"}
            value={workPlaceForm.phone}
            onChange={handleChangeWorkPlaceFormTextField}
            width="410px"
          />
        </FlexRightContainer>
      </FlexContainer>
    </SelectRecentLocationCardContainer>
  );
};

const SelectRecentLocationCardContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const FlexLeftContainer = styled.div`
  width: 87px;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: ${theme.palette.primitives.gray800};
`;

const FlexRightContainer = styled.div`
  display: flex;
  align-items: center;
`;

const FloorField = styled.div`
  margin-left: 12px;
  font-weight: 500;
  font-size: 15px;
  line-height: 18px;
  color: ${theme.palette.primitives.gray600};
`;

const PostCodeButtonContainer = styled.div`
  margin-left: 12px;
`;
